module.exports = __webpack_public_path__ + "img/pageRightDis.2a5ad4cb.svg";